// extracted by mini-css-extract-plugin
export var addressFields = "_or-0";
export var animationContainer = "_or-1";
export var footer = "_or-2";
export var lineItems = "_or-3";
export var modalContent = "_or-4";
export var orderName = "_or-5";
export var strong = "_or-6";
export var warning = "_or-7";